import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { useUserStore } from "@/modules/auth/store/user";
import { formatNumber } from "@/modules/auth/utils/format";
import { useMatchingBonusValueStore } from "@/modules/matching-bonus/store/value";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface Props {
  onClose: () => void;
}

const SuccessfulMatchingBonus = ({ onClose }: Props) => {
  const { t } = useTranslation();

  const { setMatchingBonus, airdrop } = useUserStore();

  const { value, currentToken, setValue } = useMatchingBonusValueStore();

  const navigate = useNavigate();

  const goToMain = async () => {
    await navigate("/");
  };

  const closeModalRedirect = async () => {
    await setMatchingBonus();
    await goToMain();
    onClose();
    setValue("");
  };

  return (
    <Modal
      title={t("withdraw-page.successful_withdrawal")}
      onClose={closeModalRedirect}
    >
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <img src="/images/ok.png" alt="" className="w-32 h-32" />
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.25rem] leading-[1.5625rem] font-semibold text-text">
            {t("matching-bonus-page.rewards", {
              amount:
                currentToken === "token"
                  ? formatNumber(parseFloat(value))
                  : formatNumber(parseFloat(value) - (airdrop.fee || 0)),
              token: currentToken === "token" ? "BTN" : "TON",
            })}
          </p>
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {t("matching-bonus-page.tokens_credited")}
          </p>
        </div>

        <Button
          onClick={closeModalRedirect}
          text={t("withdraw-page.to_main")}
          size="large"
          className="w-full"
        />
      </div>
    </Modal>
  );
};

export default SuccessfulMatchingBonus;
